import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import * as constants from '../constants/system-setup-constants';

import type {List, MapOf} from 'immutable';

export type SsGeneralStore = {
    options: MapOf<{
        timezone: List<string>;
        locale: List<string>;
    }>;
};

// always support America/New_York and en-US
const initialState = () => {
    return {
        options: Immutable.fromJS({
            timezone: ['America/New_York'],
            locale: ['en-US'],
        }) as SsGeneralStore['options'],
    };
};

const actionsMap = {
    [constants.TIMEZONES_SUCCESS]: (state, action) => {
        const timezones = action.data
            .map((tz) => {
                return tz.get('name');
            })
            .sort();

        return {
            options: state.options.merge(
                Immutable.Map({
                    timezone: timezones,
                }),
            ),
        };
    },
    [constants.LOCALES_SUCCESS]: (state, action) => {
        return {
            options: state.options.merge(
                Immutable.Map({
                    locale: action.data,
                }),
            ),
        };
    },
    [constants.DISPOSE_SS_GENERAL_SETTINGS_STORE]: () => {
        return initialState();
    },
};

export default createReducer<SsGeneralStore>(initialState(), actionsMap);
